import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/chat-sandbox")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/cindy-sandbox", search: search as never, replace: true });
  },
});
